import { createGlobalState } from "react-hooks-global-state";

const initialState = {
  language: "",
};

export const { useGlobalState } = createGlobalState(initialState);
